import { TranscriptSearchList } from './components/TranscriptSearchList';

const TranscriptSearchPage = () => {
  return <TranscriptSearchList />;
};

export default TranscriptSearchPage;
